import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/calendar-times': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M311.7 374.7L294.7 391.7C290 396.4 282.4 396.4 277.7 391.7L224 337.9 170.3 391.6C165.6 396.3 158 396.3 153.3 391.6L136.3 374.6C131.6 369.9 131.6 362.3 136.3 357.6L190 303.9 136.3 250.2C131.6 245.5 131.6 237.9 136.3 233.2L153.3 216.2C158 211.5 165.6 211.5 170.3 216.2L224 269.9 277.7 216.2C282.4 211.5 290 211.5 294.7 216.2L311.7 233.2C316.4 237.9 316.4 245.5 311.7 250.2L257.9 304 311.6 357.7C316.4 362.4 316.4 370 311.7 374.7zM448 112V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112zM400 458V160H48V458C48 461.3 50.7 464 54 464H394C397.3 464 400 461.3 400 458z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/calendar-times.js
// module id = /2Zk
// module chunks = 144